import './home.css';

import Section from '../../components/section/Section';
import Hero from '../../components/hero/Hero';

const Home = () => {
  return (
    <div className='home'>
        <Section />
        <Hero />
    </div>
  )
}

export default Home